export enum TierOptionsAzure {
  BASIC = "Basic",
  STANDARD = "Standard"
}
